import React from "react";
import { FormattedMessage } from "react-intl";

export const contract = [
  { value: true, name: <FormattedMessage id="CreateDomainLabel.trial" /> },
  { value: false, name: <FormattedMessage id="CreateDomainLabel.thisAgreement" /> }
];
export const mode = [
  { value: "expire", name: <FormattedMessage id="CreateDomainLabel.expireMode" /> },
  { value: "valid", name: <FormattedMessage id="CreateDomainLabel.validMode" /> },
  { value: "invalid", name: <FormattedMessage id="CreateDomainLabel.invalidMode" /> }
];
export const roles = [
  { value: "", name: "choose" },
  { value: "1", name: "Domain Admin" },
  { value: "2", name: "Domain Guest" }
];

export const selectarr = [
  {
    name: "video_logo_remove",
    label: <FormattedMessage id="CreateDomainLabel.videoLogoRemove" />
  },
  {
    name: "video_direct_mobile",
    label: <FormattedMessage id="CreateDomainLabel.videoDirectMobile" />
  },
  {
    name: "video_invite_modal_remove",
    label: <FormattedMessage id="CreateDomainLabel.videoInviteModalRemove" />
  },
  {
    name: "video_display_name_remove",
    label: <FormattedMessage id="CreateDomainLabel.videoDisplayNameremove" />
  },
  {
    name: "video_webrtc_stats_remove",
    label: <FormattedMessage id="CreateDomainLabel.videoWebrtcStatsRemove" />
  },
  {
    name: "video_webrtc_stats_log_enable",
    label: <FormattedMessage id="CreateDomainLabel.videoWebrtcStatsLogEnable" />
  },
  {
    name: "video_fullscreen_remove",
    label: <FormattedMessage id="CreateDomainLabel.videoFullscreenRemove" />
  },
  {
    name: "video_mobile_default_backcamera_enable",
    label: <FormattedMessage id="CreateDomainLabel.backcamera" />
  },
  {
    name: "video_text_chat_remove",
    label: <FormattedMessage id="CreateDomainLabel.textChat" />
  },
  {
    name: "video_audio_guest_mode",
    label: <FormattedMessage id="CreateDomainLabel.audioGuestMode" />
  },
  {
    name: "video_remote_audio_remove",
    label: <FormattedMessage id="CreateDomainLabel.remoteVideo" />
  },
  {
    name: "video_local_recording_remove",
    label: <FormattedMessage id="CreateDomainLabel.recordingRemoveVideo" />
  },
  {
    name: "video_settings_remove",
    label: <FormattedMessage id="CreateDomainLabel.settingsRemoveVideo" />
  },
  // {name: 'video_enable_firefox', label: <FormattedMessage id='CreateDomainLabel.enableFirefox'/>},
  {
    name: "video_mirror_enable",
    label: <FormattedMessage id="CreateDomainLabel.enableMirror" />
  }
];
export const optionInputText = [
  {
    name: "video_end_url",
    label: <FormattedMessage id="CreateDomainLabel.videoEndURL" />,
    type: "text"
  },
  {
    name: "video_google_analytics",
    label: <FormattedMessage id="CreateDomainLabel.videoGoogle" />,
    type: "text"
  },
  {
    name: "video_mobile_upper_video_view_size",
    label: <FormattedMessage id="CreateDomainLabel.upperVideoSize" />,
    type: "number"
  }
];
export const select = [
  { value: "", label: "choose" },
  { value: true, label: "True" },
  { value: false, label: "False" }
];

export const video_codec = [
  { value: "VP8", label: "VP8" },
  { value: "H264", label: "H264" }
];

export const fvdomain_types = [
  { value: "Path Domain", label: "Path Domain" },
  { value: "Sub Domain", label: "Sub Domain" }
];

export const colorInputField = [
  {
    name: "video_color_bottom_action_button",
    label: <FormattedMessage id="CreateDomainLabel.colorBottomBtn" />
  },
  {
    name: "video_color_end_call_button",
    label: <FormattedMessage id="CreateDomainLabel.colorEndCallBtn" />
  },
  {
    name: "video_header_left_color",
    label: <FormattedMessage id="CreateDomainLabel.headerLetfColor" />
  },
  {
    name: "video_header_right_color",
    label: <FormattedMessage id="CreateDomainLabel.headerRightColor" />
  }
];

export const webRtc = [
  {
    name: "video_webrtc_stun_sever",
    label: <FormattedMessage id="CreateDomainLabel.webRtcStunServer" />,
    type: "text"
  },
  {
    name: "video_webrtc_stun_sever_port",
    label: <FormattedMessage id="CreateDomainLabel.webRtcStunServerPort" />,
    type: "number"
  },
  {
    name: "video_webrtc_turn_sever",
    label: <FormattedMessage id="CreateDomainLabel.webRtcTurnServer" />,
    type: "text"
  },
  {
    name: "video_webrtc_turn_sever_port",
    label: <FormattedMessage id="CreateDomainLabel.webRtcTurnServerPort" />,
    type: "number"
  }
];

export const pcGetUserMedia = [
  {
    name: "pc_framerate_ideal",
    label: <FormattedMessage id="CreateDomainLabel.pcFramerateIdeal" />,
    type: "number"
  },
  {
    name: "pc_framerate_max",
    label: <FormattedMessage id="CreateDomainLabel.pcFramerateMax" />,
    type: "number"
  },
  {
    name: "pc_video_width_min",
    label: <FormattedMessage id="CreateDomainLabel.pcVideoWidthMin" />,
    type: "number"
  },
  {
    name: "pc_video_width_ideal",
    label: <FormattedMessage id="CreateDomainLabel.pcVideoWidthIdeal" />,
    type: "number"
  },
  {
    name: "pc_video_height_min",
    label: <FormattedMessage id="CreateDomainLabel.pcVideoHeightMin" />,
    type: "number"
  },
  {
    name: "pc_video_height_ideal",
    label: <FormattedMessage id="CreateDomainLabel.pcVideoHeightIdeal" />,
    type: "number"
  }
];

export const mobileGetUserMedia = [
  {
    name: "mobile_framerate_ideal",
    label: <FormattedMessage id="CreateDomainLabel.mobileFramerateIdeal" />,
    type: "number"
  },
  {
    name: "mobile_framerate_max",
    label: <FormattedMessage id="CreateDomainLabel.mobileFramerateMax" />,
    type: "number"
  },
  {
    name: "mobile_video_width_min",
    label: <FormattedMessage id="CreateDomainLabel.mobileVideoWidthMin" />,
    type: "number"
  },
  {
    name: "mobile_video_width_ideal",
    label: <FormattedMessage id="CreateDomainLabel.mobileVideoWidthIdeal" />,
    type: "number"
  },
  {
    name: "mobile_video_height_min",
    label: <FormattedMessage id="CreateDomainLabel.mobileVideoHeightMin" />,
    type: "number"
  },
  {
    name: "mobile_video_height_ideal",
    label: <FormattedMessage id="CreateDomainLabel.mobileVideoHeightIdeal" />,
    type: "number"
  }
];



// WEBPACK FOOTER //
// src/routes/Domain/domainComponent.js